export default {
    blog: {
        Search: '搜尋',
        posts: ' 帖文',
        column: '欄表',
        list: '列表',
        toggle: '切換樣式',
        noFilter: '沒有篩選',
        article: '文章',
        minRead: ' 分鐘閱讀',
        articles: '文章',
        disc: 'NobleWills 真誠地準備的指南和文章僅供參考。 其聲明、指引或內容均不應構成專家意見或推薦。 在本平台上包含任何公司的名稱、標識或其他辨認均不構成對這些公司的商品或服務的認可或推薦。',
        tempDisc:
            '免責聲明： 本文僅供一般資訊參考之用，並不構成任何法律意見或建議。雖然部分簡單的遺產安排可透過可靠的網上遺囑工具自行處理，但涉及較複雜的情況，仍建議諮詢具資格的專業人士，以獲取度身訂造的法律建議。',
    },
};
